<div
    *ngIf="
        (!showOnTouch && control && control?.invalid) ||
        (showOnTouch && control && control?.invalid && (control?.touched || control?.dirty))
    "
    class="{{ errorMessageStyle }}"
    [style.right.px]="rightOffset"
    [style.left.px]="leftOffset"
    [style.top.px]="topOffset"
    [style.bottom.px]="bottomOffset"
>
    <div *ngIf="control.errors.required">* {{ name }} is required</div>
    <div *ngIf="control.errors.maxlength" class="{{ errorMessageStyle }}">
        * {{ name }} is too long
    </div>
    <div *ngIf="control.errors.minlength" class="{{ errorMessageStyle }}">
        * {{ name }} is too small
    </div>
    <div *ngIf="control.errors.hasZero" class="{{ errorMessageStyle }}">
        * {{ name }} must not be equal to zero.
    </div>
    <div *ngIf="control.errors.email" class="{{ errorMessageStyle }}">
        * {{ control.value }} is not a valid email.
    </div>
    <div *ngIf="control.errors.notUnique" class="{{ errorMessageStyle }}">
        * {{ control.value }} must be unique.
    </div>
    <div *ngIf="control.errors.shortNameNotUnique" class="{{ errorMessageStyle }}">
        * {{ control.value }} must be unique.
    </div>
    <div *ngIf="control.errors.clientKeyNotUnique" class="{{ errorMessageStyle }}">
        * {{ control.value }} must be unique
    </div>
    <div *ngIf="control.errors.zeroPaddingEntityRule" class="{{ errorMessageStyle }}">
        * Cannot enable zero padding after there is more than one entity or employee
    </div>
    <div *ngIf="control.errors.zeroPaddingRequired" class="{{ errorMessageStyle }}">
        * {{ control.value }} must be padded to at least {{ optionalInput }} characters.
    </div>
</div>
